<h1 mat-dialog-title>User Right</h1>
<div mat-dialog-content>
    <div *ngIf="(licenseState$ | async).loading" class="loading-content-wrapper">
        <mat-icon class="loading-icon">autorenew</mat-icon>
        <b class="loading-text">Requesting User Right</b>
    </div>
    <div class="no-license-wrapper" *ngIf="!(licenseState$ | async).loading && !(licenseState$ | async).active">
        <b *ngIf="(licenseState$|async).totalLicenses - (licenseState$|async).usedLicenses > 0"
           class="no-license-text">{{(licenseState$|async).totalLicenses - (licenseState$|async).usedLicenses}} user
            right(s) currently available</b>
        <div *ngIf="(licenseState$|async).totalLicenses - (licenseState$|async).usedLicenses <= 0">
            <b class="no-license-text">No user rights currently available</b>
            <mat-icon class="loading-icon icon-margin">autorenew</mat-icon>
        </div>

        <div class="license-request-buttons-container">
            <button *ngIf="(licenseState$|async).totalLicenses - (licenseState$|async).usedLicenses > 0"
                    mat-raised-button color="primary" id="license-request-try-again-button" class="critical"
                    (click)="activateDevice()">Activate Device
            </button>
            <button mat-raised-button color="accent" class="critical"
                    (click)="logout()">Logout
            </button>
        </div>

    </div>
</div>
